// Notification type from https://labcorp.invisionapp.com/d/main#/console/17369991/364620358/preview

export class NotificationTypes {
  static PRIMARY = 'primary';
  static DANGER = 'danger';
  static INFO = 'info';
  static WARNING = 'warning';
  static SUCCESS = 'success';


  static iconNames = {
    primary: 'get_app',
    success: 'check_circle',
    danger: 'warning',
    info: 'info',
    warning: 'error'
  };
}
